const appConfig = {
    apiPrefix: 'https://kimeragt.ahlamkom.net',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig